import { useNavigate } from "react-router-dom";
import Modal from "../../../../components/portal/Modal";
import GradientButton from "../../../../components/UI/buttonUI/GradientButton";
import successIcon from "../../../../assets/icons/successIcon.svg";

export default function JobCardSuccessView({ message, checkIcon  }) {
  const navigate = useNavigate(0);
  return (
    <Modal
      onClose={() => navigate(0)}
      modalWidth="max-w-md w-11/12 2xs:max-sm:w-95% 2xs:max-md:px-4 2xs:max-md:py-4 pb-8 pt-8 px-8"
      closeIcon={true}
    >
    {checkIcon && <img src={successIcon} alt="messageIcon" className="mx-auto mb-1 w-9" /> }  
      <p className="view-success-msg-d">{message}</p>
      <div className="pt-5 text-center">
        <GradientButton btnText="Ok" width="w-28" onClick={() => navigate(0)} />
      </div>
    </Modal>
  );
}
